module.exports = __webpack_public_path__ + "static/media/registry-title.9fe11c1f.svg";